module.exports = __webpack_public_path__ + "media/images/top-5-2dda4db8a95efb70e52d0657fce60e52.png";